import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >
<path d="M2460 6067 c-270 -53 -490 -267 -544 -530 -32 -155 -14 -286 60 -437
38 -77 61 -109 123 -170 120 -118 220 -168 385 -195 203 -33 409 37 566 194
83 83 132 165 170 286 30 95 31 270 2 365 -40 131 -80 202 -165 289 -79 81
-164 134 -275 171 -109 37 -224 46 -322 27z m259 -108 c85 -19 164 -63 259
-144 34 -29 92 -112 118 -170 125 -274 21 -601 -238 -744 -104 -58 -186 -75
-317 -68 -156 9 -266 55 -366 156 -94 95 -139 178 -167 305 -13 61 -5 213 16
277 80 255 324 422 586 402 36 -2 85 -9 109 -14z"/>
<path d="M2643 5925 c-59 -18 -123 -57 -166 -102 -20 -20 -37 -40 -37 -44 0
-3 38 -30 85 -58 203 -125 289 -266 236 -387 -74 -167 -227 -184 -484 -54
l-98 49 -14 -33 c-23 -54 -28 -130 -15 -200 14 -76 22 -83 127 -114 210 -64
404 -22 544 118 163 162 199 379 98 589 -33 67 -58 102 -124 168 -46 46 -89
83 -97 82 -7 0 -32 -6 -55 -14z"/>
<path d="M2355 5614 c-38 -24 -89 -53 -112 -65 l-43 -22 33 -57 c17 -31 39
-67 48 -80 l16 -24 121 70 c137 78 133 68 75 165 -21 35 -42 59 -52 58 -9 -1
-47 -21 -86 -45z m159 -80 c8 -21 -1 -34 -25 -34 -12 0 -19 7 -19 18 0 34 33
45 44 16z"/>
<path d="M6590 5685 c0 -135 -4 -205 -10 -205 -6 0 -21 9 -33 20 -24 23 -106
50 -152 50 -17 0 -54 -6 -83 -13 -252 -66 -328 -442 -126 -626 105 -96 252
-110 364 -34 44 29 50 29 50 -2 l0 -25 104 0 c99 0 104 1 110 23 8 29 8 931 0
980 l-7 37 -108 0 -109 0 0 -205z m-56 -378 c55 -37 73 -139 33 -198 -77 -116
-246 -77 -264 60 -10 70 35 144 95 157 15 3 32 7 37 8 17 5 75 -11 99 -27z"/>
<path d="M3650 5720 l0 -120 135 0 135 0 0 -375 0 -376 123 3 122 3 2 370 2
370 136 3 135 3 0 119 0 120 -395 0 -395 0 0 -120z"/>
<path d="M7720 5626 l0 -95 -52 -3 -53 -3 -3 -87 -3 -88 56 0 55 0 0 -160 c0
-136 3 -167 21 -214 39 -106 125 -152 266 -144 76 5 170 39 188 68 4 6 -12 42
-34 79 l-41 69 -43 -16 c-46 -17 -86 -12 -111 14 -13 13 -16 42 -16 160 l0
144 95 0 95 0 0 90 0 90 -95 0 -95 0 0 95 0 95 -115 0 -115 0 0 -94z"/>
<path d="M8964 5686 c-3 -7 -4 -35 -2 -62 l3 -49 63 -3 62 -3 0 66 0 65 -60 0
c-42 0 -62 -4 -66 -14z"/>
<path d="M4664 5541 c-56 -14 -129 -56 -174 -101 -81 -80 -113 -181 -98 -307
14 -117 89 -216 206 -271 49 -23 70 -27 152 -27 116 0 171 19 244 83 180 160
163 432 -37 565 -87 58 -199 80 -293 58z m163 -233 c100 -61 75 -228 -39 -258
-55 -15 -111 2 -143 44 -20 26 -25 44 -25 90 0 65 18 104 59 129 37 24 106 21
148 -5z"/>
<path d="M5582 5536 c-23 -8 -58 -26 -77 -40 -43 -33 -45 -33 -45 4 l0 30
-110 0 -110 0 0 -525 0 -525 115 0 115 0 0 205 c0 113 3 205 6 205 3 0 26 -12
52 -27 42 -25 57 -28 137 -28 78 0 97 4 140 27 220 116 246 457 47 620 -70 57
-188 81 -270 54z m115 -233 c45 -33 56 -57 55 -121 -1 -93 -62 -147 -156 -139
-43 4 -55 10 -88 45 -34 37 -38 47 -38 92 0 80 27 121 97 145 47 16 88 9 130
-22z"/>
<path d="M7150 5540 c-47 -10 -131 -49 -168 -78 l-24 -18 29 -33 c99 -116 100
-117 120 -100 58 52 142 62 199 24 25 -16 61 -82 50 -92 -2 -3 -33 2 -68 11
-81 20 -117 20 -190 0 -72 -21 -151 -86 -169 -142 -24 -72 -8 -158 37 -207 47
-52 85 -68 166 -73 85 -5 146 11 186 49 24 22 44 17 40 -9 -3 -15 11 -17 110
-20 l113 -3 -3 243 -3 243 -30 53 c-35 64 -71 97 -143 130 -60 27 -177 37
-252 22z m147 -425 c54 -16 65 -28 53 -60 -15 -39 -48 -59 -109 -63 -50 -4
-62 -1 -80 17 -47 47 -7 111 75 120 6 0 33 -6 61 -14z"/>
<path d="M8500 5536 c-174 -50 -270 -192 -257 -377 9 -141 77 -242 197 -298
79 -36 212 -42 307 -12 69 21 163 81 163 104 0 6 -22 36 -48 65 l-47 54 -53
-28 c-104 -54 -218 -40 -262 31 -11 18 -20 35 -20 39 0 3 103 6 229 6 l230 0
7 45 c20 137 -58 281 -190 345 -75 37 -182 48 -256 26z m158 -172 c22 -15 52
-63 52 -84 0 -6 -41 -10 -115 -10 -98 0 -115 2 -115 16 0 68 118 120 178 78z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
